export function scrollPageToTop(options = {}) {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const behavior = options.behavior || "auto";
  const scrollOptions = { top: 0, left: 0, behavior };
  const documentScroller = document.scrollingElement || document.documentElement;

  if (documentScroller && typeof documentScroller.scrollTo === "function") {
    documentScroller.scrollTo(scrollOptions);
  }

  window.scrollTo(scrollOptions);

  document
    .querySelectorAll("[data-page-scroll-container]")
    .forEach((container) => {
      if (typeof container.scrollTo === "function") {
        container.scrollTo(scrollOptions);
      } else {
        container.scrollTop = 0;
      }
    });
}
